import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import HistoryOfCinnamon from './pages/HistoryOfCinnamon';
import Technology from './pages/Technology';
import OurProducts from './pages/OurProducts';
import ProductDetail from './pages/ProductDetail';
import ShopNow from './pages/ShopNow';
import OrderPage from './pages/OrderPage';
import ContactUs from './pages/ContactUs';
import Cart from './pages/Cart';

function App() {
  return (
    <BrowserRouter>
      <div className="d-flex flex-column min-vh-100">
        <Navbar />
        <main className="flex-grow-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/history" element={<HistoryOfCinnamon />} />
            <Route path="/technology" element={<Technology />} />
            <Route path="/products" element={<OurProducts />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/shop" element={<ShopNow />} />
            <Route path="/order/:category" element={<OrderPage />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/cart" element={<Cart />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;